// Import all necessary Firebase services
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';
import { getRemoteConfig } from 'firebase/remote-config';

// Your web app's Firebase configuration
// Can be overridden via environment variables (VITE_FIREBASE_*)
const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCTKt5jTIz18LOWs3dfy-4BPJg73N208c0',
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'zippedriveralpha.firebaseapp.com',
	databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || 'https://zippedriveralpha-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'zippedriveralpha',
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'zippe-development.appspot.com',
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '839094425920',
	appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:839094425920:web:7c2b9e251956eb74d702a5'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const rtdb = getDatabase(app);
const storage = getStorage(app);
const messaging = getMessaging(app);
const remoteConfig = getRemoteConfig(app);

// Configure Remote Config settings
remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour in production

// Always log Firebase config for diagnostics (including production)
console.log('[Firebase Config] Initialized:', {
	projectId: firebaseConfig.projectId,
	authDomain: firebaseConfig.authDomain,
	apiKeyPrefix: firebaseConfig.apiKey?.substring(0, 20) + '...',
	environment: import.meta.env.MODE,
	hasEnvOverrides: {
		apiKey: !!import.meta.env.VITE_FIREBASE_API_KEY,
		projectId: !!import.meta.env.VITE_FIREBASE_PROJECT_ID,
		authDomain: !!import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	},
});

// Detailed logging in development
if (import.meta.env.DEV) {
	console.log('Firebase initialized with full config:', firebaseConfig);
	console.log('Firebase app:', app);
	console.log('Auth service:', auth);
	console.log('Firestore service:', db);
	console.log('Realtime Database service:', rtdb);
	console.log('Storage service:', storage);
}

// Export initialized services and functions
export { app, auth, db, rtdb, storage, messaging, remoteConfig };
